export default class BraintreeClient {
	static getBraintreeConfig() {
		const { braintreeConfig = {} } = window?.od;
		return braintreeConfig;
	}

	constructor() {
		if (this.constructor === BraintreeClient) {
			throw new Error(
				'This is an abstract class. Do not instantiate it directly.',
			);
		}

		this.braintree = window.braintree;
		this.paymentToken = BraintreeClient.getBraintreeConfig().paymentToken;
		this.form = document.getElementById('orderReviewForm');
		this.termsAndConditionsCheckbox =
			document.getElementById('termsAndConditions');
		[this.dataLayer] = window.dataLayer;
		this.navigation = this.dataLayer.navigation;
		this.currency = this.navigation.currencyISO;
	}

	get amount() {
		return this.getCartDataSync()?.cartData?.amount;
	}

	createClient() {
		return this.braintree.client.create({ authorization: this.paymentToken });
	}

	disableButton(id) {
		const button = document.getElementById(id);
		button.classList.add('disabled');
		button.setAttribute('disabled', '');
		button.setAttribute('readonly', '');
	}

	enableButton(id) {
		const button = document.getElementById(id);
		button.classList.remove('disabled');
		button.removeAttribute('disabled');
		button.removeAttribute('readonly');
	}

	createHiddenInput(name, value) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value;
		return input;
	}

	submitFormWithBraintreeNonce(form, nonce) {
		const hiddenNonceInput = this.createHiddenInput('braintreeNonce', nonce);
		form.appendChild(hiddenNonceInput);
		form.submit();
	}

	redirectToBillingPage() {
		const { location } = window;
		const checkoutBillingURL = location.href.replace('review', 'billing');
		location.assign(checkoutBillingURL);
	}

	getCartDataSync() {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', '/ajax/payment/local/cart/data', false); // Note: async: false
		xhr.send();

		if (xhr.status === 200) {
			try {
				const jsonResponse = JSON.parse(xhr.responseText);
				return jsonResponse.data;
			} catch (e) {
				throw new Error(errorTranslations.braintree.cartData.fetch.error);
			}
		}
		throw new Error(errorTranslations.braintree.cartData.fetch.error);
	}
}
